export const STORAGE_KEY = 'patrimoffice-client'



// WEBPACK FOOTER //
// ./src/store/state.js